module.exports = __webpack_public_path__ + "img/img-8.1bbaec47.png";